import Vue from 'vue';
import VueRouter from 'vue-router';
import { login } from './login.js';
import { relic } from './relic.js';
// import { report } from './report.js';
import { user } from './user.js';
import { manage } from './manage.js';
// import { gis } from './gis.js';
import { map } from './map.js';
// import store from '../store'
// import {roleJudge} from '../config/roleJudge'
// const authorizationLimit= store.state.login.authorizationLimit
// import { tagManage } from './tag-manage';
// import { repair } from './repair';

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routes = [
  {
    path: '/',
    redirect: { name: 'Login' }
  },
  ...login,
  ...relic,
  // ...report,
  ...manage,
  ...user,
  // ...gis,
  ...map
  // ...tagManage,
  // ...repair
];

const router = new VueRouter({
  // mode:'history',
  base: process.env.BASE_URL,
  routes
});
// router.beforeEach((to, from, next) => {
//   const login = 'Login';
//   // 登录页直接放行
//   if (to.name === login) return next();
//   const token = localStorage.getItem('token');
//   if (!token) {
//     return next({
//       name: login,
//       query: { redirect: encodeURI(location.href) }
//     });
//   }
//   next();
// });
export default router;
